import { StatusRequest } from '../../../../../../core/models/request-status.model';
import { PaginationModel } from '@spartacus/core';

export enum COUNTER_RESULT_TYPE {
  PAGES = 'PAGES',
  PRODUCTS = 'PRODUCTS',
  LITERATURES = 'LITERATURES',
}

export interface CounterResult {
  label: string; // Product | Pages
  path: string; // /search || /search-pages
  type: COUNTER_RESULT_TYPE;
  qty: number;
  disabled?: boolean;
  class?: string;
}

export interface CounterResultsRequest extends StatusRequest {
  results?: CounterResult[];
  pagination?: PaginationModel;
}
